"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _filterUtils = require("@nicbase/filter-utils");

var _request = require("@nicbase/request");

var _types = require("@nicbase/types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var findAdminGatewayAccounts = function findAdminGatewayAccounts(_ref) {
  var dynamicFilters = _ref.dynamicFilters,
      dynamicPaging = _ref.dynamicPaging,
      dynamicSorters = _ref.dynamicSorters;
  return {
    type: 'ADMIN_FIND_ALL_GATEWAY_ACCOUNTS_REQUEST',
    headers: {
      version: 'v2'
    },
    body: {
      dynamicFilters: dynamicFilters,
      dynamicPaging: dynamicPaging,
      dynamicSorters: dynamicSorters
    }
  };
};

var attributeMapping = {
  id: 'account.id',
  name: 'account.name',
  portalId: 'account.portal.id',
  portalName: 'account.portal.name',
  providerId: 'account.provider.id',
  providerName: 'account.provider.name',
  createdAt: 'account.createdAt',
  editedAt: 'account.editedAt',
  activeBoxesTotal: 'account.activeBoxesTotal',
  lastBoxdataReceived: 'account.lastBoxdataReceived'
};

var useAdminGatewayAccounts = function useAdminGatewayAccounts() {
  var requestParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var queryOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var _requestParams$filter = requestParams.filters,
      filters = _requestParams$filter === void 0 ? {} : _requestParams$filter,
      _requestParams$pageSi = requestParams.pageSize,
      pageSize = _requestParams$pageSi === void 0 ? null : _requestParams$pageSi,
      _requestParams$sortin = requestParams.sorting;
  _requestParams$sortin = _requestParams$sortin === void 0 ? {} : _requestParams$sortin;
  var _requestParams$sortin2 = _requestParams$sortin.sortBy,
      sortBy = _requestParams$sortin2 === void 0 ? 'id' : _requestParams$sortin2,
      _requestParams$sortin3 = _requestParams$sortin.sortDirection,
      sortDirection = _requestParams$sortin3 === void 0 ? 'ASC' : _requestParams$sortin3;
  var id = filters.id,
      name = filters.name,
      portalId = filters.portalId,
      providerId = filters.providerId;
  return (0, _reactQuery.useInfiniteQuery)(['admin', 'gatewayAccounts', {
    id: id,
    name: name,
    portalId: portalId,
    providerId: providerId,
    sortBy: sortBy,
    sortDirection: sortDirection,
    pageSize: pageSize
  }], /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var _ref2$pageParam, pageNumber, pagination, hasNoPortalOption, portalIds, idClause, validIds, nameClause, validNames, _and, filterTree, _yield$request, _yield$request$body, accounts, totalRows;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2$pageParam = _ref2.pageParam, pageNumber = _ref2$pageParam === void 0 ? 0 : _ref2$pageParam;

              if (pageSize) {
                pagination = {
                  pageNumber: pageNumber,
                  pageSize: pageSize
                };
              } // explicitly search for portalId with null value ("account not assigned to any portal")


              hasNoPortalOption = false;
              portalIds = null;

              if (Array.isArray(portalId)) {
                hasNoPortalOption = portalId.includes(null);
                portalIds = portalId.filter(Boolean);

                if (portalIds.length < 1) {
                  portalIds = null;
                }
              } // Widened id: scalar -> equal; array -> isIn (filter out non-finite values); empty array -> no clause.


              idClause = null;

              if (Array.isArray(id)) {
                validIds = id.filter(function (n) {
                  return Number.isFinite(n);
                });

                if (validIds.length > 0) {
                  idClause = (0, _filterUtils.isIn)('account.id', validIds, _types.FilterAttributeType.Integer);
                }
              } else if (id !== undefined && id !== null) {
                idClause = (0, _filterUtils.equal)('account.id', id, _types.FilterAttributeType.Integer);
              } // Widened name: scalar -> like; array -> or(...likes); empty array -> no clause.


              nameClause = null;

              if (Array.isArray(name)) {
                validNames = name.filter(function (n) {
                  return typeof n === 'string' && n.length > 0;
                });

                if (validNames.length > 0) {
                  nameClause = _filterUtils.or.apply(void 0, _toConsumableArray(validNames.map(function (n) {
                    return (0, _filterUtils.like)('account.name', n, _types.FilterAttributeType.String);
                  })));
                }
              } else if (name !== undefined && name !== null && name !== '') {
                nameClause = (0, _filterUtils.like)('account.name', name, _types.FilterAttributeType.String);
              }

              _and = (0, _filterUtils.and)(idClause, nameClause, (0, _filterUtils.or)(hasNoPortalOption ? (0, _filterUtils.isNull)('account.portal.id') : null, (0, _filterUtils.isIn)('account.portal.id', portalIds, _types.FilterAttributeType.Integer)), (0, _filterUtils.isIn)('account.provider.id', providerId, _types.FilterAttributeType.Integer)), filterTree = _and.filterTree;
              _context.next = 12;
              return request(findAdminGatewayAccounts({
                dynamicFilters: filterTree,
                dynamicPaging: pagination,
                dynamicSorters: [{
                  attributeName: attributeMapping[sortBy],
                  sortOrder: sortDirection
                }]
              }));

            case 12:
              _yield$request = _context.sent;
              _yield$request$body = _yield$request.body;
              accounts = _yield$request$body.accounts;
              totalRows = _yield$request$body.totalRows;
              return _context.abrupt("return", {
                accounts: accounts,
                totalRows: totalRows
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), _objectSpread({
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      var _lastPage$accounts;

      if (pageSize === null || ((_lastPage$accounts = lastPage.accounts) === null || _lastPage$accounts === void 0 ? void 0 : _lastPage$accounts.length) < pageSize) {
        return undefined;
      }

      return allPages.length;
    }
  }, queryOptions));
};

var _default = useAdminGatewayAccounts;
exports["default"] = _default;